import { useQuery } from '@tanstack/react-query';
import { fetchListingPreview } from '../../lib/leasing.api';

/** Query key for the draft preview. Nothing invalidates it: it is never stale (staleTime 0, refetched on every mount). */
const listingPreviewKey = (id: string) => ['listing-preview', id] as const;

/**
 * The landlord's draft preview (BR-108, BR-109): the public projection of a draft Listing built from
 * saved data only. Always refetched on mount so it never shows what was edited but not yet saved.
 */
export function useListingPreview(id: string) {
  return useQuery({
    queryKey: listingPreviewKey(id),
    queryFn: () => fetchListingPreview(id),
    enabled: id !== '',
    staleTime: 0,
    refetchOnMount: 'always',
    // 404 is the answer (not a draft, or not yours): do not retry it.
    retry: (failureCount, error) => (error as { status?: number }).status !== 404 && failureCount < 1,
  });
}
